import * as React from 'react'
function SvgFx(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 4c1.2 0 2 .8 2 2v28c0 1.2-.8 2-2 2H6c-1.2 0-2-.8-2-2V6c0-1.2.8-2 2-2h28zm-2 4H8v24h24V8zm-3 6.2c1 .6 1.2 1.8.6 2.8l-4 6c-.6 1-2.2 1.2-3 .4L18.2 19l-4.6 6.2c-.6.8-2 1-2.8.4-.8-.6-1-2-.4-2.8l6-8c.8-1 2.2-1 3-.2l4.2 4.2 2.6-4c.6-1 1.8-1.2 2.8-.6z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgFx
